module.exports = __webpack_public_path__ + "static/media/YouthArtsCamp.b7b00f4b.jpg";